import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Car, Check } from "lucide-react";
import { useVehicle } from "../lib/vehicleContext";

export const VehiclePicker = () => {
  const { vehicle, vehicles, setVehicleId } = useVehicle();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        data-testid="vehicle-picker-trigger"
        className="flex items-center gap-3 bg-black/40 border border-white/10 hover:border-white/25 rounded-xl px-3 py-2.5 transition-colors min-w-[260px]"
        aria-expanded={open}
      >
        <div
          className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
          style={{ background: "rgba(57,255,20,0.08)" }}
        >
          <Car className="w-4 h-4" style={{ color: "#39FF14" }} strokeWidth={1.8} />
        </div>
        <div className="text-left flex-1 min-w-0">
          <div className="text-sm text-white font-medium truncate">
            {vehicle.year} {vehicle.name}
          </div>
          <div className="font-mono text-[10px] text-zinc-500 truncate">
            VIN {vehicle.vin} · {vehicle.odometer.toLocaleString()} mi
          </div>
        </div>
        <ChevronDown
          className={`w-4 h-4 text-zinc-500 transition-transform ${open ? "rotate-180" : ""}`}
          strokeWidth={2}
        />
      </button>

      {open && (
        <div
          className="absolute right-0 mt-2 w-[320px] z-50 rounded-xl border border-white/10 bg-[#0a0a0a] shadow-2xl shadow-black/60 backdrop-blur overflow-hidden"
          data-testid="vehicle-picker-menu"
        >
          <div className="px-4 py-2.5 border-b border-white/5 text-[10px] font-mono uppercase tracking-[0.2em] text-zinc-500">
            Switch vehicle
          </div>
          <div className="max-h-[360px] overflow-y-auto">
            {vehicles.map((v) => {
              const isActive = v.id === vehicle.id;
              return (
                <button
                  key={v.id}
                  onClick={() => {
                    setVehicleId(v.id);
                    setOpen(false);
                  }}
                  data-testid={`vehicle-option-${v.id}`}
                  className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-white/[0.04] transition-colors border-l-2 ${
                    isActive ? "border-l-[#39FF14] bg-white/[0.03]" : "border-l-transparent"
                  }`}
                >
                  <div className="flex-1 min-w-0">
                    <div className="text-sm text-white font-medium truncate">
                      {v.year} {v.name}
                    </div>
                    <div className="font-mono text-[10px] text-zinc-500 truncate mt-0.5">
                      SoH {v.sohCurrent}% · {v.odometer.toLocaleString()} mi · {v.color}
                    </div>
                  </div>
                  {isActive && (
                    <Check className="w-4 h-4" style={{ color: "#39FF14" }} strokeWidth={2.5} />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
